import axios from './axios';


export default class{
    static async upload(file){
        const formData=new FormData();
        formData.append("file",file);
        return await axios.post("/file/save",formData)
    }
}